// extracted by mini-css-extract-plugin
export default {"container":"styles_container__AwSle","title":"styles_title__80CC+","value":"styles_value__kWnQE","tooltip":"styles_tooltip__W+aIv"};